export const AccountDetailsTabNameEnum = Object.freeze({
    MEMBERSHIPS: 'memberships',
    CONTACTS: 'contacts',
    ADDRESSES: 'addresses',
    ORDERS: 'orders',
});
